if (!customElements.get('collapsible-description')) {
  customElements.define(
    'collapsible-description',
    class CollapsibleDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-description]');
        this.extras = this.querySelectorAll('[data-collapse-extra]');
        this.toggle = this.querySelector('[data-collapse-toggle]');
        if (!this.toggle) return;

        this.evaluate();

        this.toggle.addEventListener('click', () => {
          // Grow downward only: hold this block's top edge where it is. The reveal happens above
          // the button, so any scroll the browser does on its own (scroll anchoring, or focusing
          // the button in engines that don't focus it on click) reads as the panel expanding
          // upward. The delta is normally 0 — non-zero exactly when the browser moved us.
          const before = this.getBoundingClientRect().top;
          this.expanded ? this.collapse(false) : this.expand(false);
          const delta = this.getBoundingClientRect().top - before;
          if (delta) window.scrollBy(0, delta);
        });

        // Re-check when a reflow could change whether the toggle is needed —
        // but never disturb a panel the reader has already opened.
        window.addEventListener(
          'resize',
          this.debounce(() => {
            if (!this.expanded) this.evaluate();
          }, 150)
        );
      }

      // Decide whether a toggle is needed. `is-enhanced` gates the clamp and the
      // hiding of extras in CSS, so without JS everything stays fully visible.
      evaluate() {
        this.classList.add('is-enhanced');
        this.collapse(true);

        const introOverflows = this.content
          ? this.content.scrollHeight - this.content.clientHeight > 2
          : false;
        const needsToggle = introOverflows || this.extras.length > 0;

        this.toggle.hidden = !needsToggle;
        if (!needsToggle) {
          this.classList.remove('is-enhanced');
          this.expand(true);
        }
      }

      expand(silent) {
        this.expanded = true;
        this.classList.remove('is-collapsed');
        this.toggle.setAttribute('aria-expanded', 'true');
        if (!silent) this.toggle.focus({ preventScroll: true });
      }

      collapse(silent) {
        this.expanded = false;
        this.classList.add('is-collapsed');
        this.toggle.setAttribute('aria-expanded', 'false');
        if (!silent) this.toggle.focus({ preventScroll: true });
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }
  );
}
